import React from "react";
import PropTypes from "prop-types";
import {
  DATA_COUNT_LIMIT,
  SOCIAL_SOURCES,
  SHARE_COUNT_LIMIT,
} from "../../../../constants/static-filter";

const { FACEBOOK, INSTAGRAM, YOUTUBE, PINTEREST, TWITTER } = SOCIAL_SOURCES;

function SocialCountFilters({ filters, setFilters, channelType = [] }) {
  const isFB = channelType.indexOf(FACEBOOK) !== -1;
  const isTW = channelType.indexOf(TWITTER) !== -1;
  const isIG = channelType.indexOf(INSTAGRAM) !== -1;
  // const isPIN = channelType.indexOf(PINTEREST) !== -1;
  const isYT = channelType.indexOf(YOUTUBE) !== -1;

  const shouldShowLikeFilter = () => {
    return isFB || isIG || isYT;
  };

  const shouldShowDislikeFilter = () => {
    return isYT;
  };

  const shouldShowShareFilter = () => {
    return isYT || isIG || isFB;
  };

  const filterConfig = [
    {
      label: "Comments",
      filterKey: "commentsCount",
      show: true,
      options: DATA_COUNT_LIMIT,
    },
    {
      label: "Share / Retweet",
      filterKey: "shareOrRetweetCount",
      show: shouldShowShareFilter(),
      options: SHARE_COUNT_LIMIT,
    },
    {
      label: "Likes",
      filterKey: "likesCount",
      show: shouldShowLikeFilter(),
      options: DATA_COUNT_LIMIT,
    },
    // TODO: To be done as part of CB-476
    // {
    //   label: "Dislikes",
    //   filterKey: "dislikeCount",
    //   show: shouldShowDislikeFilter(),
    // },
    // {
    //   label: "Views",
    //   filterKey: "viewsCount",
    //   show: isYT,
    // },
  ];

  const isSelected = (fKey, value) => {
    return filters[fKey] == value;
  };

  const handleSelect = (e, filterKey) => {
    const selectedValue = e.target.value;
    setFilters({
      ...filters,
      [filterKey]: selectedValue,
    });
  };

  return (
    <React.Fragment key={channelType.length}>
      {filterConfig.map((filter, index) => {
        const { label, filterKey, options } = filter;
        // TODO: use show property of options to conditionaly hide filters based on platform.
        const identity = `${label}-${index}`;
        return (
          <div key={identity} className="form-group">
            <div className="filterDiv filteInputText">
              <label>{label}</label>
              <select
                className="form-control"
                id={identity}
                onChange={(e) => handleSelect(e, filterKey)}
              >
                <option value={0}>All</option>
                {options.map((el) => {
                  const faceLabel = el.label || el.value || el;
                  const faceValue = el.value || el.label || el;
                  return (
                    <option
                      selected={isSelected(filterKey, faceValue)}
                      value={faceValue}
                    >
                      {faceLabel}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
}

SocialCountFilters.propTypes = {
  filters: PropTypes.shape({}),
  setFilters: PropTypes.func,
};

SocialCountFilters.defaultProps = {
  filters: {},
  setFilters: () => {},
};

export default SocialCountFilters;
